module.exports = __webpack_public_path__ + "img/like.394bd8fe.png";